import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionButton } from 'ui/actionButton/ActionButton';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';

import { DeleteGroupGlcPermissionProps } from './DeleteGroupGlcPermission.types';

export const DeleteGroupGlcPermission = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
}: DeleteGroupGlcPermissionProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();

  return (
    <>
      <ActionButton type="delete" onClick={onModalOpen} disabled={!perms?.UPR_GRUPOWE?.edit} />

      <ActionModal
        header={formatMessage({ id: AppMessages['group.reader.permission.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['group.reader.permission.delete.button'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['group.glc.permission.delete.subtitle'] })}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['group.reader.permission.delete.text'] })}</ActionModal.Text>

        <ActionModal.Text>{formatMessage({ id: AppMessages['common.irreversibleAction'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
